import gql from 'graphql-tag';

import dokkioLabelFragment from '../fragments/dokkioLabelFragment';

export const queryDokkioLabels = gql`
  query dokkioLabels {
    dokkioLabels {
      ...dokkioLabelFragment
    }
  }
  ${dokkioLabelFragment}
`;
export default queryDokkioLabels;
